import * as React from "react";
import {
  AccessorFn,
  ColumnHelper,
  DeepKeys,
  DisplayColumnDef,
  HeaderContext,
  RowData
} from "@tanstack/react-table";

import { CheckboxStyled } from "src/library/components/Forms";

/**
 * standard checkbox column which can take a header component to be rendered in the header
 * also takes in a handler function for the onchange of the checkbox
 */
export const checkboxColumn = <TData extends RowData, TAccessor = AccessorFn<TData> | DeepKeys<TData> >(
  columnHelper: ColumnHelper<TData>,
  column: Partial<Pick<DisplayColumnDef<TData>, "header" | "enableSorting" | "cell" | "meta" | "enableColumnFilter">>,
  accessor: TAccessor,
  handler?: (data: TData) => void,
  bulkActions?: (info: HeaderContext<TData, unknown>) => React.ReactNode,
) => {
  return columnHelper.accessor(accessor as DeepKeys<TData>, {
    id: column.header ? column.header : "checkbox",
    size: bulkActions ? 160 : 20,
    header: bulkActions ? bulkActions : column.header,
    enableSorting: false,
    minSize: 50,
    enableColumnFilter: column.enableColumnFilter ? column.enableColumnFilter : false,
    cell: column.cell || !handler ? column.cell : info => {
      return (
        <CheckboxStyled
          checked={info.getValue() as boolean}
          onChange={() => {
            handler(info.row.original as TData);
          }}
        />
      );
    },
    meta: column.meta ? column.meta : {
      filter: {
        filterType: "select",
        options: [
          {
            text: "Selected",
            value: "true"
          },
          {
            text: "Deselected",
            value: "false"
          }
        ]
      }
    }
  } as DisplayColumnDef<TData>,);
};